import React from 'react';
import { Grid, Button, Row, Col } from 'antd';
import indexStyles from '../index.less';
import { JoinClassName } from 'src/utils/utils';
import CommonGetDemoTopSection, { CommonGetDemoTopSectionOnLeft } from '../CommonGetDemoTopSection';
import AutoPlayer from 'src/components/AutoPlayer';
import { FormattedMessage } from 'react-intl';
import Link from 'next/link';
import TopScheduleYourFreeDemo from 'src/components/POSWebsite/TopScheduleYourFreeDemo';
const { useBreakpoint } = Grid;

const ProductTopIntroduction = ({
  title,
  description,
  descriptionHtml,
  poster,
  videoId,
  forBusiessType = false,
  topLink,
}) => {
  const screens = useBreakpoint();
  const hasVideoId = !!videoId;
  return (
    <React.Fragment>
      <Row align={'middle'} justify={'center'} wrap={false}>
        <Col xs={24}>
          <div
            className={JoinClassName(
              indexStyles.productTopIntroductionForLoyaltyModeWrapper,
              screens.md ? indexStyles.forMDDevice : '',
              screens.xs ? indexStyles.forMobile : ''
            )}
            style={{ minHeight: 'auto', marginBottom: 80, flexWrap: 'wrap' }}
          >
            {forBusiessType && hasVideoId ? (
              <CommonGetDemoTopSection
                title={title}
                desc={description}
                descHtml={descriptionHtml}
                topLink={topLink}
                className={JoinClassName(
                  indexStyles.max1440WidthFull,
                  indexStyles.productTopIntroduction,
                  forBusiessType && hasVideoId ? indexStyles.oneRow : ''
                )}
                outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
              >
                <div style={{ textAlign: 'center' }}>
                  {topLink ? (
                    <Button shape="round" type="primary" href={topLink.href} size="large" onClick={() => {}}>
                      {topLink.text}
                    </Button>
                  ) : null}
                </div>
              </CommonGetDemoTopSection>
            ) : (
              <CommonGetDemoTopSectionOnLeft
                title={title}
                desc={description}
                descHtml={descriptionHtml}
                topLink={topLink}
                className={JoinClassName(
                  indexStyles.max1440WidthFull,
                  indexStyles.productTopIntroduction,
                  forBusiessType && hasVideoId ? indexStyles.oneRow : ''
                )}
                outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
              >
                <div style={{ textAlign: 'center' }}>
                  {topLink ? (
                    <Button shape="round" type="primary" href={topLink.href} size="large" onClick={() => {}}>
                      {topLink.text}
                    </Button>
                  ) : null}
                </div>
              </CommonGetDemoTopSectionOnLeft>
            )}
            {forBusiessType && hasVideoId && (
              <React.Fragment>
                <div style={{ flex: 644, minWidth: '100%' }}>
                  <Row align={'middle'} justify={'center'} wrap={true} gutter={[10]}>
                    <Col xs={24} lg={12}>
                      {poster && (
                        <div
                          className={JoinClassName(
                            indexStyles.productVideoContainerWrapper,
                            screens.xs ? indexStyles.forMobile : ''
                          )}
                        >
                          <Row align={'middle'} justify={'center'} wrap={false}>
                            <Col xs={24}>
                              <div
                                className={JoinClassName(indexStyles.productVideoContainer)}
                                style={{ marginBottom: 0 }}
                              >
                                <AutoPlayer
                                  poster={`${poster}`}
                                  posterAlt={title}
                                  posterRatio={videoId ? 428 / 641 : 9 / 16}
                                  youtubeVideoId={videoId}
                                  autoPlayOnCover={true}
                                  centerButtonType={'pureButton'}
                                  canPause={true}
                                />
                              </div>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </Col>
                    <Col xs={24} lg={12}>
                      <div
                        className={JoinClassName(indexStyles.productLoyaltyVideoContainerWrapper)}
                        style={{ flex: 864, marginLeft: 10 }}
                      >
                        <TopScheduleYourFreeDemo triggerSource={'banner'} showModel={'lightGray_background'} />
                      </div>
                    </Col>
                  </Row>
                </div>
              </React.Fragment>
            )}
            {(!forBusiessType || !hasVideoId) && (
              <React.Fragment>
                <div
                  className={JoinClassName(indexStyles.productLoyaltyVideoContainerWrapper)}
                  style={{ flex: 864, marginLeft: 10, width: '100%' }}
                >
                  <TopScheduleYourFreeDemo triggerSource={'banner'} showModel={'lightGray_background'} />
                </div>
              </React.Fragment>
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export const ProductTopIntroductionForLoyaltyMode = ({ title, description, poster, videoId, topLink }) => {
  const screens = useBreakpoint();
  return (
    <Row align={'middle'} justify={'center'} wrap={false}>
      <Col xs={24}>
        <div
          className={JoinClassName(
            indexStyles.productTopIntroductionForLoyaltyModeWrapper,
            screens.md ? indexStyles.forMDDevice : ''
          )}
        >
          <CommonGetDemoTopSectionOnLeft
            title={title}
            desc={description}
            topLink={topLink}
            className={JoinClassName(indexStyles.max1440WidthFull, indexStyles.productTopIntroduction)}
            // outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
          >
            <div style={{ textAlign: 'left' }}>
              {topLink ? (
                <Button
                  shape="round"
                  href={topLink.href}
                  size="large"
                  onClick={() => {}}
                  style={{ color: '#E00051', borderColor: '#E00051' }}
                >
                  {topLink.text}
                </Button>
              ) : (
                <Link href="/get-a-demo">
                  <a>
                    <Button
                      shape="round"
                      size="large"
                      style={{ color: '#E00051', borderColor: '#E00051', paddingTop: 0, paddingBottom: 0 }}
                    >
                      <FormattedMessage id="home.get-demo.bitton" />
                    </Button>
                  </a>
                </Link>
              )}
            </div>
          </CommonGetDemoTopSectionOnLeft>
          <div className={JoinClassName(indexStyles.productLoyaltyVideoContainerWrapper)}>
            <Row align={'middle'} justify={'center'} wrap={false}>
              <Col xs={23}>
                <div className={JoinClassName(indexStyles.productVideoContainer)}>
                  <AutoPlayer
                    poster={`${poster}`}
                    posterAlt={title}
                    posterRatio={videoId ? 428 / 641 : 9 / 16}
                    youtubeVideoId={videoId}
                    autoPlayOnCover={true}
                    centerButtonType={'pureButton'}
                    canPause={true}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default ProductTopIntroduction;
